module.exports = __webpack_public_path__ + "fonts/Font3.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/components/reusableComponents/AutoGenerateSignature/fonts/Font3.ttf
// module id = 1732
// module chunks = 0